(function () {
  /**
   * Wave 22A / FS-017 + FS-020 — facet allowlist (ADR-205: now driven by the per-section row map).
   * Hide Prestige facet accordion groups that are not
   * availability / price / vendor (Flutter PLP filter dimensions) or a row of the page's
   * section family (see isAllowedName), at every
   * viewport width — Flutter's filter set is the same regardless of screen
   * size, so there is no desktop-native reason to show additional facets.
   * Applied filters stay in the form (display:none only) so query params
   * are not orphaned on submit.
   *
   * Prestige accordion roots have no data-param; classify via input[name]
   * patterns from snippets/facets.liquid + price-range.liquid.
   *
   * Prestige facet:update replaces section children AFTER theme:loading:end,
   * so a MutationObserver re-applies after DOM swap.
   */
  if (window.__erosPlpFacetAllowlistBound) return;
  window.__erosPlpFacetAllowlistBound = true;

  var HIDDEN = 'eros-facet-hide-mobile';
  var SECTION_SEL =
    '.shopify-section--main-collection, .shopify-section--main-search';
  var scheduled = false;

  /*
   * ADR-205: the per-section row map (eros-plp-tray-logic.js, ErosPlpTrayLogic) decides which
   * facet groups the legacy drawer/sidebar may show - the same rows the filter tray renders, so
   * both UIs always agree. The section family comes from the majority eros.section of the page's
   * products (JSON emitted by snippets/eros-plp-filter-tray.liquid). Without that module or data
   * (tray assets failed to load, no products) it falls back to the Wave 22A set:
   * availability / price / vendor.
   */
  var familyCache = null;

  function currentFamily() {
    if (familyCache !== null) return familyCache;
    var logic = window.ErosPlpTrayLogic;
    var node = document.querySelector('script[data-eros-plp-tray-data]');
    if (!logic || !node) return '';
    try {
      var data = JSON.parse(node.textContent);
      familyCache = logic.familyOf(logic.majoritySection(data.sections));
    } catch (e) {
      return '';
    }
    return familyCache;
  }

  function isBaseName(name) {
    if (name === 'filter.v.availability' || name.indexOf('filter.v.availability.') === 0) {
      return true;
    }
    if (name.indexOf('filter.v.price') === 0) return true;
    if (name === 'filter.p.vendor' || name.indexOf('filter.p.vendor.') === 0) {
      return true;
    }
    return false;
  }

  function isAllowedName(name) {
    if (!name || typeof name !== 'string') return false;
    if (isBaseName(name)) return true;
    var family = currentFamily();
    return !!family && window.ErosPlpTrayLogic.isAllowedParam(family, name);
  }

  function accordionIsAllowed(accordion) {
    var inputs = accordion.querySelectorAll('input[name*="filter."]');
    if (!inputs.length) return false;
    for (var i = 0; i < inputs.length; i++) {
      if (isAllowedName(inputs[i].getAttribute('name'))) return true;
    }
    return false;
  }

  function applyAllowlist() {
    familyCache = null; /* section can change after a facet:update swap */
    var forms = document.querySelectorAll('facets-form');
    for (var f = 0; f < forms.length; f++) {
      var accordions = forms[f].querySelectorAll('.accordion-list > .accordion');
      for (var a = 0; a < accordions.length; a++) {
        var el = accordions[a];
        if (accordionIsAllowed(el)) {
          el.classList.remove(HIDDEN);
        } else {
          el.classList.add(HIDDEN);
        }
      }
    }
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      applyAllowlist();
    });
  }

  function bindSectionObservers() {
    if (!('MutationObserver' in window)) return;
    var secs = document.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < secs.length; i++) {
      if (secs[i].dataset.erosFacetAllowlistMo) continue;
      secs[i].dataset.erosFacetAllowlistMo = '1';
      new MutationObserver(scheduleApply).observe(secs[i], {
        childList: true,
        subtree: true,
      });
    }
  }

  function boot() {
    bindSectionObservers();
    scheduleApply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('facet:update', scheduleApply);
  document.addEventListener('theme:loading:end', scheduleApply);
  document.addEventListener('shopify:section:load', function () {
    bindSectionObservers();
    scheduleApply();
  });
})();
